import { render, staticRenderFns } from "./BusinessUnit.vue?vue&type=template&id=a0845802&scoped=true&"
import script from "./BusinessUnit.vue?vue&type=script&lang=js&"
export * from "./BusinessUnit.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnit.vue?vue&type=style&index=0&id=a0845802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0845802",
  null
  
)

export default component.exports